import { Link } from "react-router-dom";
import "./afficheProduitmagasin.css";
import EmptyCartPopup from "../../../components/EmptyCartPopup";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { useContext, useEffect, useState } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import axios from "axios";
import DefaulteImage from "../../Utilisateure/visiteur/DefaulteImage.jpeg";
import { getFormattedImageUrl, handleImageError } from "../../../Services/ImageUrlHelper";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import ArticlesLoader from "../../../components/ArticlesLoader";

/* ─── Commission resolution helper ─── */
function resolveCommission(
  rules: any[],
  myMagasinName?: string,
  productMagasinName?: string
): number {
  const glob = rules.find((r: any) => r.commission_type === 'global');
  return glob ? parseFloat(glob.commission_value) || 0 : 0;
}

function calcPriceWithCommission(price: any, commissionPct: number): string {
  const p = parseFloat(String(price).replace(',', '.'));
  if (isNaN(p)) return '0.00';
  const total = p + (p * commissionPct / 100);
  const truncated = Math.floor(total * 100 + 0.00001) / 100;
  return truncated.toFixed(2);
}

interface Product {
  IdArticle: number;
  refArticle: any;
  designation: string;
  urlImage: string;
  quantity: number;
  Remise: string;
  NomMagasin: string;
  prix: number;
}

const AfficheProduitsMagasin: React.FC<ArticleInfo> = ({
  IdArticle,
  Designation,
  prixTtc,
  PrixVenteArticleTTC,
  Description,
  urlImage,
  stock,
  quantité,
  NomMagasin,
  Remise,
  RefArticle,
  LibelleSubstitut,
  prix_ht_2_magasin,
  prix2,
  prix_ht_1_magasin,
  loading,
}) => {
  const resolvedQty = quantité !== undefined ? quantité : stock;
  console.log(resolvedQty);
  const [value, setValue] = useState(1);
  const [addingToCart, setAddingToCart] = useState(false);
  const [added, setAdded] = useState(false);
  const [ShowSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);

  const handleGoBack = () => { window.history.back(); };

  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");
  const id = MagasinId || magasinContext.id?.id;
  const MagasinName = localStorage.getItem("MagasinName") || magasinContext.id?.NomMagasin || magasinContext.id?.Nom_magasin;
  const isMyProduct = Boolean(
    MagasinName && NomMagasin && MagasinName.trim().toLowerCase() === NomMagasin.trim().toLowerCase()
  );
  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);

  /* ── commission rules ── */
  const [commissionRules, setCommissionRules] = useState<any[]>([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`)
      .then(r => setCommissionRules(r.data || []))
      .catch(() => setCommissionRules([]));
  }, []);

  const getCommission = (productMagasinName: string): number => {
    return resolveCommission(commissionRules, MagasinName || '', productMagasinName || '');
  };

  // For own products → show original price; for others → apply global WYN commission
  const displayPriceVal = isMyProduct
    ? parseFloat(String(PrixVenteArticleTTC).replace(',', '.')) || 0
    : parseFloat(calcPriceWithCommission(PrixVenteArticleTTC, getCommission(NomMagasin || '')));
  const displayPriceStr = displayPriceVal.toFixed(2);

  const addProductToPanier = async (
    IdArticle: number,
    refArticle: string,
    image: string,
    designation: string,
    PrixVenteArticleTTC: number,
    NomMagasin: string
  ) => {
    setAddingToCart(true);
    try {
      // PrixVenteArticleTTC here is already the displayed price (commission-included)
      const finalPrice = parseFloat(String(PrixVenteArticleTTC).replace(',', '.'));
      const fd = new FormData();
      fd.append("IdUtilisateur",   id ?? "");
      fd.append("TypeUtilisiteur", "magasins");
      fd.append("IdArticle",       String(IdArticle));
      fd.append("RefArticle",      refArticle);
      fd.append("Designation",     designation);
      fd.append("Image",           image || urlImage || DefaulteImage);
      fd.append("price",           finalPrice.toFixed(2));
      fd.append("quantity",        String(value));
      fd.append("NomMagasin",      NomMagasin);
      fd.append("seller",          NomMagasin);
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier`, fd);
      setAdded(true);
          setShowSuccessPopup(true);

    const timeoutId = setTimeout(() => {
      setShowSuccessPopup(false);
    }, 2000);
      setTimeout(() => setAdded(false), 1800);
      window.dispatchEvent(new Event("panier-updated"));
    } catch (e) {
      console.error(e);
    } finally {
      setAddingToCart(false);
    }
  };

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ──────────────────────────────────────────────
     MOBILE VIEW  (≤ 450px)
  ────────────────────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
        <NewSideBarMagasins />
        {loading ? (
          <ArticlesLoader />
        ) : (
          <div className="mobile-container-dpmu">

            {/* ── Image + back ── */}
            <div className="mobile-product-container-dpmu">

              {/* Back button */}
              <button className="mobile-back-btn-dpmu" onClick={handleGoBack}>
                <i className="bi bi-arrow-left-short" />
              </button>

              {/* Product image */}
              <img
                src={getFormattedImageUrl(urlImage)}
                alt={Designation}
                className="mobile-product-img-dpmu"
                onError={handleImageError}
              />

              {/* Sticky add-to-cart */}
              {!isMyProduct && (
              <button
                className="ajouter-panier-mobile-dpmu"
                disabled={addingToCart || (resolvedQty !== undefined && Number(resolvedQty) <= 0)}
                onClick={() =>
                  addProductToPanier(
                    IdArticle ?? 0,
                    RefArticle,
                    urlImage,
                    Designation,
                    displayPriceVal,
                    NomMagasin ?? ""
                  )
                }
                style={{
                  opacity: (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? 0.6 : 1,
                  cursor: (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? "not-allowed" : "pointer"
                }}
              >
                {added ? (
                  <><i className="bi bi-check-lg" /> Ajouté</>
                ) : addingToCart ? (
                  <><span className="btn-spinner-dpmu" /> Ajout...</>
                ) : (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? (
                  <>Stock épuisé <i className="bi bi-x-circle" /></>
                ) : (
                  "Ajouter"
                )}
              </button>
              )}
            </div>

            {/* ── Content ── */}
            <div className="mobile-content-dpmu">

              {/* Title */}
              <div className="mobile-product-title-dpmu">
                <h3>{Designation}</h3>
              </div>

              {/* Stock badge */}
              <div className="mobile-stock-row-dpmu">
                {resolvedQty !== undefined && Number(resolvedQty) <= 0 ? (
                  <span className="stock-epuise-dpmu">
                    Stock épuisé <i className="bi bi-exclamation-lg" />
                  </span>
                ) : resolvedQty !== undefined && Number(resolvedQty) < 10 ? (
                  <span className="stock-low-dpmu" style={{ color: "#ef4444", fontWeight: 700 }}>
                    Stock faible : {resolvedQty} <i className="bi bi-exclamation-triangle" />
                  </span>
                ) : (
                  <span className="stock-ok-dpmu">En stock : {resolvedQty}</span>
                )}
              </div>

              {/* Out-of-stock CTA */}
              {quantité !== undefined && quantité === 0 && (
                <Link
                  to={`/magasins/${id}/demande/articles/${RefArticle}`}
                  className="btn-da-dpmu"
                >
                  <i className="bi bi-plus-square" /> Demander l'article
                </Link>
              )}

              {/* Price + Ref */}
              <div className="mobile-detail-row-dpmu">
                <div className="mobile-price-dpmu">
                  Prix Net HT : {displayPriceStr} MAD
                </div>
                <div className="mobile-ref-dpmu">
                  <strong>Ref :</strong> {RefArticle}
                </div>
              </div>

              {/* Rating */}
              <div className="mobile-rating-dpmu">
                <svg width="17" height="17" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.70843 0.837349C8.93892 0.37041 9.05416 0.136941 9.21061 0.062347C9.34673 -0.00255318 9.50487 -0.00255318 9.64099 0.062347C9.79744 0.136941 9.91268 0.37041 10.1432 0.837349L12.3298 5.26732C12.3979 5.40517 12.4319 5.47409 12.4816 5.52761C12.5257 5.57499 12.5785 5.61338 12.6371 5.64065C12.7033 5.67146 12.7794 5.68257 12.9315 5.70481L17.8228 6.41974C18.3378 6.49502 18.5954 6.53267 18.7146 6.65847C18.8183 6.76792 18.867 6.91833 18.8473 7.06781C18.8246 7.23961 18.6382 7.42121 18.2653 7.78441L14.7272 11.2305C14.6169 11.3379 14.5618 11.3916 14.5262 11.4555C14.4947 11.5121 14.4745 11.5742 14.4667 11.6385C14.4579 11.7112 14.4709 11.787 14.4969 11.9388L15.3317 16.8061C15.4198 17.3195 15.4638 17.5762 15.3811 17.7285C15.3091 17.8611 15.1811 17.954 15.0328 17.9815C14.8624 18.0131 14.6319 17.8919 14.1709 17.6494L9.79816 15.3499C9.66191 15.2782 9.59379 15.2424 9.52202 15.2283C9.45848 15.2159 9.39312 15.2159 9.32957 15.2283C9.2578 15.2424 9.18968 15.2782 9.05344 15.3499L4.6807 17.6494C4.2197 17.8919 3.98919 18.0131 3.81875 17.9815C3.67046 17.954 3.5425 17.8611 3.47052 17.7285C3.38778 17.5762 3.43181 17.3195 3.51986 16.8061L4.35467 11.9388C4.38069 11.787 4.39371 11.7112 4.3849 11.6385C4.3771 11.5742 4.35689 11.5121 4.32539 11.4555C4.2898 11.3916 4.23466 11.3379 4.12437 11.2305L0.586341 7.78441C0.213444 7.42121 0.0269959 7.23961 0.00430753 7.06781C-0.0154326 6.91833 0.0333348 6.76792 0.137032 6.65847C0.256216 6.53267 0.513753 6.49502 1.02882 6.41974L5.92009 5.70481C6.07221 5.68257 6.14826 5.67146 6.2145 5.64065C6.27315 5.61338 6.32594 5.57499 6.36997 5.52761C6.41969 5.47409 6.45371 5.40517 6.52175 5.26732L8.70843 0.837349Z" fill="#FFA928"/>
                </svg>
                <span className="mobile-rating-score-dpmu">4.0/5</span>
                <span className="mobile-rating-reviews-dpmu">(45 avis)</span>
              </div>

              {/* Description */}
              <div className="mobile-desc-dpmu">
                <p>{Description}</p>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  /* ──────────────────────────────────────────────
     DESKTOP VIEW
  ────────────────────────────────────────────── */
  return (
    <>
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      <NewSideBarMagasins />
      {loading ? (
        <ArticlesLoader />
      ) : (
        <div className="produit-card-dpmu">

          {/* Back button */}
          <button className="back-btn-dpmu" onClick={handleGoBack}>
            <i className="bi bi-arrow-left-short" /> Retour
          </button>

          {/* Title bar */}
          <div className="bar-title-dpmu">
            <h3>{Designation}</h3>
          </div>

          {/* Card */}
          <div className="card-item-dpmu">

            {/* ── Image ── */}
            <div className="product-image-block-dpmu">
              <div className="product-image-wrap-dpmu">
                <img src={getFormattedImageUrl(urlImage)} alt={Designation} onError={handleImageError} />
              </div>
            </div>

            {/* ── Info ── */}
            <div className="items-info-dpmu">

              {/* Price hero */}
              <div className="price-hero-dpmu">
                <span className="price-main-dpmu">{displayPriceStr}</span>
                <span className="price-unit-dpmu">MAD / P.U</span>
              </div>

              {/* Rating */}
              <div className="rating-row-dpmu">
                <svg width="17" height="17" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.70843 0.837349C8.93892 0.37041 9.05416 0.136941 9.21061 0.062347C9.34673 -0.00255318 9.50487 -0.00255318 9.64099 0.062347C9.79744 0.136941 9.91268 0.37041 10.1432 0.837349L12.3298 5.26732C12.3979 5.40517 12.4319 5.47409 12.4816 5.52761C12.5257 5.57499 12.5785 5.61338 12.6371 5.64065C12.7033 5.67146 12.7794 5.68257 12.9315 5.70481L17.8228 6.41974C18.3378 6.49502 18.5954 6.53267 18.7146 6.65847C18.8183 6.76792 18.867 6.91833 18.8473 7.06781C18.8246 7.23961 18.6382 7.42121 18.2653 7.78441L14.7272 11.2305C14.6169 11.3379 14.5618 11.3916 14.5262 11.4555C14.4947 11.5121 14.4745 11.5742 14.4667 11.6385C14.4579 11.7112 14.4709 11.787 14.4969 11.9388L15.3317 16.8061C15.4198 17.3195 15.4638 17.5762 15.3811 17.7285C15.3091 17.8611 15.1811 17.954 15.0328 17.9815C14.8624 18.0131 14.6319 17.8919 14.1709 17.6494L9.79816 15.3499C9.66191 15.2782 9.59379 15.2424 9.52202 15.2283C9.45848 15.2159 9.39312 15.2159 9.32957 15.2283C9.2578 15.2424 9.18968 15.2782 9.05344 15.3499L4.6807 17.6494C4.2197 17.8919 3.98919 18.0131 3.81875 17.9815C3.67046 17.954 3.5425 17.8611 3.47052 17.7285C3.38778 17.5762 3.43181 17.3195 3.51986 16.8061L4.35467 11.9388C4.38069 11.787 4.39371 11.7112 4.3849 11.6385C4.3771 11.5742 4.35689 11.5121 4.32539 11.4555C4.2898 11.3916 4.23466 11.3379 4.12437 11.2305L0.586341 7.78441C0.213444 7.42121 0.0269959 7.23961 0.00430753 7.06781C-0.0154326 6.91833 0.0333348 6.76792 0.137032 6.65847C0.256216 6.53267 0.513753 6.49502 1.02882 6.41974L5.92009 5.70481C6.07221 5.68257 6.14826 5.67146 6.2145 5.64065C6.27315 5.61338 6.32594 5.57499 6.36997 5.52761C6.41969 5.47409 6.45371 5.40517 6.52175 5.26732L8.70843 0.837349Z" fill="#FFA928"/>
                </svg>
                <span className="rating-score-dpmu">4.0/5</span>
                <span className="rating-reviews-dpmu">(45 avis)</span>
              </div>

              {/* Price + details table */}
              <div className="price-rows-dpmu">
                <div className="price-row-dpmu">
                  <strong>Prix Net HT</strong>
                  <span className="price-value-dpmu">{displayPriceStr} MAD</span>
                </div>
                <hr className="price-row-divider-dpmu" />
                <div className="price-row-dpmu">
                  <strong>Référence</strong>
                  <span className="ref-value-dpmu">{RefArticle}</span>
                </div>
                <hr className="price-row-divider-dpmu" />
                <div className="price-row-dpmu">
                  <strong>Substitut</strong>
                  <span>
                    {(Array.isArray(LibelleSubstitut) &&
                      LibelleSubstitut.length === 1 &&
                      LibelleSubstitut[0].trim() === "") ||
                    !LibelleSubstitut
                      ? "N/A"
                      : LibelleSubstitut}
                  </span>
                </div>
                <hr className="price-row-divider-dpmu" />
                <div className="price-row-dpmu">
                  <strong>Qté en stock</strong>
                  <span>
                    {resolvedQty !== undefined && Number(resolvedQty) <= 0 ? (
                      <span className="stock-epuise-dpmu">
                        Stock épuisé <i className="bi bi-exclamation-lg" />
                      </span>
                    ) : resolvedQty !== undefined && Number(resolvedQty) < 10 ? (
                      <span className="stock-low-dpmu" style={{ color: "#ef4444", fontWeight: 700 }}>
                        Stock faible : {resolvedQty} <i className="bi bi-exclamation-triangle" />
                      </span>
                    ) : (
                      <span className="stock-ok-dpmu">En stock : {resolvedQty}</span>
                    )}
                  </span>
                </div>
              </div>

              {/* Out-of-stock CTA */}
              {quantité !== undefined && quantité === 0 ? (
                <Link
                  to={`/magasins/${id}/demande/articles/${RefArticle}`}
                  className="btn-da-dpmu"
                >
                  <i className="bi bi-plus-square" /> Demander l'article
                </Link>
              ) : (
                <>
                  {/* Quantity */}
                  {!isMyProduct && (
                  <>
                    <div className="quantity-block-dpmu">
                      <span className="quantity-label-dpmu">Quantité</span>
                      <div className="quantity-control-dpmu">
                        <button
                          className="qty-btn-dpmu"
                          type="button"
                          onClick={() => setValue((v) => Math.max(1, v - 1))}
                        >
                          −
                        </button>
                        <input
                          className="input-q-dpmu"
                          value={value}
                          max={quantité}
                          min={1}
                          type="number"
                          onChange={(e: any) => setValue(Number(e.target.value))}
                        />
                        <button
                          className="qty-btn-dpmu"
                          type="button"
                          onClick={() => setValue((v) => v + 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
  
                    {/* Add to cart */}
                    <button
                      className="ajouter-p-dpmu"
                      disabled={addingToCart || (resolvedQty !== undefined && Number(resolvedQty) <= 0)}
                      onClick={() =>
                        addProductToPanier(
                          IdArticle ?? 0,
                          RefArticle,
                          urlImage,
                          Designation,
                          displayPriceVal,
                          NomMagasin ?? ""
                        )
                      }
                      style={{
                        opacity: (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? 0.6 : 1,
                        cursor: (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? "not-allowed" : "pointer",
                        background: (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? "#94a3b8" : ""
                      }}
                    >
                      {added ? (
                        <><i className="bi bi-check-lg" /> Ajouté au panier</>
                      ) : addingToCart ? (
                        <><span className="btn-spinner-dpmu" /> Ajout en cours...</>
                      ) : (resolvedQty !== undefined && Number(resolvedQty) <= 0) ? (
                        <><i className="bi bi-x-circle" /> Stock épuisé</>
                      ) : (
                        "Ajouter au panier"
                      )}
                    </button>
                  </>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Description section */}
          <div className="section-desc-dpmu">
            <h5>
              Réference : <span>{RefArticle}</span>
            </h5>
            {Description && (
              <div className="description-dpmu">
                <p>{Description}</p>
              </div>
            )}
          </div>

          {/* Success popup */}
          {ShowSuccessPopup && (
            <div className="popup-success-dpmu">
              <div className="popup-content-dpmu">
                <div className="popup-icon-dpmu">
                  <i className="bi bi-check-circle-fill" />
                </div>
                <h5>Produit dans le panier !</h5>
                <p>Le produit est bien ajouté au panier</p>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AfficheProduitsMagasin;